import { render, staticRenderFns } from "./PlaceOfTemporaryWork.vue?vue&type=template&id=0b9dc7f4"
import script from "./PlaceOfTemporaryWork.vue?vue&type=script&lang=js"
export * from "./PlaceOfTemporaryWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports